import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import { Menu } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
  ) {}

  public getChildMenu(id?: number): Observable<Menu[]> {
    return this.http
      .get<Array<Menu>>(this.baseUrl + 'api/menu', {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }).pipe(
        map(menu => this.filterMenu(menu, id))
      );
  }

  public getSubMenu(url: string): Observable<Menu[]> {
    return this.getChildMenu()
      .pipe(
        map(menu => {
          return menu.find(
            (m) => m.menname.toLowerCase() === url.toLowerCase()
          ).menu1;
        })
      );
  }
  private filterMenu(menu: Menu[], id?: number): Menu[] {
    if (!id) {
      return menu;
    } else {
      return menu.find((m) => m.menid === id).menu1;
    }
  }
}
